export default function (error: any, data?: any) {
  window.dispatchEvent(new CustomEvent('reportErrorToFaro', { detail: data ? { error, data } : { error } }));
}
